import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-79ec6eae")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AudioOutline = _resolveComponent("AudioOutline")
  const _directive_contextmenu = _resolveDirective("contextmenu")

  return (_openBlock(), _createBlock("div", {
    class: ["editable-element-image", { 'lock': _ctx.elementInfo.lock }],
    style: {
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px',
    }
  }, [
    _createVNode("div", {
      class: "rotate-wrapper",
      style: { transform: `rotate(${_ctx.elementInfo.rotate}deg)` }
    }, [
      _withDirectives(_createVNode("div", {
        class: "element-content",
        style: {
          filter: _ctx.shadowStyle ? `drop-shadow(${_ctx.shadowStyle})` : '',
          transform: _ctx.flipStyle,
        },
        onMousedown: _cache[1] || (_cache[1] = $event => _ctx.handleSelectElement($event))
      }, [
        _createVNode(_component_AudioOutline, { elementInfo: _ctx.elementInfo }, null, 8, ["elementInfo"]),
        _createVNode("div", {
          class: "image-content",
          style: { clipPath: _ctx.clipShape.style}
        }, [
          _createVNode("audio", {
            class: "audioPPT",
            src: _ctx.elementInfo.src,
            style: {
              position: 'absolute',
              top: '15%',
              left: '5%',
              width: '90%',
              height: '70%',
            },
            controls: "controls",
            controlslist: "nodownload",
            disablePictureInPicture: true
          }, null, 8, ["src"])
        ], 4)
      ], 36), [
        [_directive_contextmenu, _ctx.contextmenus]
      ])
    ], 4)
  ], 6))
})